import React, { useEffect } from 'react';
import { Alert, InputGroupText } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Form, Field } from '@availity/form';
import * as yup from 'yup';
import '@availity/yup';
import * as authActions from '../../store/auth/actions';
import AuthShell from '../../components/Common/AuthShell';

const ForgetPassword = () => {
  const error = useSelector((state) => state.Auth.error);
  const success = useSelector((state) => state.Auth.success);
  const loading = useSelector((state) => state.Auth.loading);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.resetMessages());
  }, []);

  const handleValidSubmit = ({ email }) => {
    dispatch(authActions.passwordForget(email));
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Tell us your email and we will send you the link to set a new password."
      footer={
        <p className="mb-0">
          Remembered it?{' '}
          <Link to="/login" className="font-weight-medium text-primary">
            Back to sign in
          </Link>
        </p>
      }
    >
      {error !== '' && <Alert color="danger">{error}</Alert>}
      {success !== '' && <Alert color="success">{success}</Alert>}
      <Form
        initialValues={{ email: '' }}
        onSubmit={handleValidSubmit}
        validationSchema={yup.object().shape({
          email: yup.string().email().required(),
        })}
      >
        <Field
          name="email"
          label="Email"
          type="email"
          placeholder="Enter email"
          prepend={
            <InputGroupText>
              <i className="bx bx-envelope"></i>
            </InputGroupText>
          }
        />
        <button
          className="btn btn-primary btn-block waves-effect waves-light mt-3 py-2"
          type="submit"
          disabled={loading}
        >
          <i
            className={`bx ${
              loading ? 'bx-loader bx-spin' : 'bx-mail-send'
            } font-size-16 align-middle mr-2`}
          ></i>
          Send the reset link
        </button>
      </Form>
    </AuthShell>
  );
};

export default withRouter(ForgetPassword);
